import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Button, Form, Modal, InputGroup  } from "react-bootstrap";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../CommonCSS/SocietyCSS.css";
import Select from 'react-select';
import { common } from "@mui/material/colors";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Bank_Reconciliation = () => {

  const [fromVchrDate, setFromVchrDate] = useState(false);
  const [toVchrDate, setToVchrDate] = useState(false);

  const [ddl_CB_Code, setDDL_CB_Code] = useState();
  const [ddl_CB_Codes, setDDL_CB_Codes] = useState([]);
  const [ddlSection, setDdlSection] = useState();
  const [ddlSections, setDdlSections] = useState([]);

  // Table rows
  const [detailRows, setDetailRows] = useState([
    { sect_id: "", fin_year1: "", vchr_no: "", vchr_type: "", cb_code: "", 
      vchr_date: "", bank_name: "", chq_no: "", amount: "", drcr: "", bank_date: "" },
  ]);

  // Fetch dropdown lists
  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const [ CashBankRes, SectionRes] =
          await Promise.all([
            axios.get(`${BASE_URL}/api/ddl_Bank_Mast`),
            axios.get(`${BASE_URL}/api/ddl_sections`),
          ]);

        setDetailRows([]);
        setDDL_CB_Codes(CashBankRes.data);
        setDdlSections(SectionRes.data);

      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }

    };

    fetchDropdowns();

  }, []);


  // Handle detail row change
  const handleDetailChange = (index, e) => {

    let { name, value } = e.target;
    const updated = [...detailRows];
    updated[index][name] = value;
    setDetailRows(updated);

  };

  // Handle button actions
  const handleShowData = async () => {

    if (!ddlSection || ddlSection === '') {
      toast.error('Please select Section.');
      return;
    } else if (!ddl_CB_Code || ddl_CB_Code === '') {
      toast.error('Please select Bank Name.');
      return;
    } else if (!fromVchrDate || fromVchrDate === '') {
      toast.error('Please enter From Voucher Date.');
      return;
    } else if (!toVchrDate || toVchrDate === '') {
      toast.error('Please enter To Voucher Date.');
      return;
    } else if (fromVchrDate > toVchrDate) {
      toast.error('From Voucher Date is greater than To Voucher Date.');
      return;
    }

    const response = await axios.get(`${BASE_URL}/api/get_BankReco`, {
                     params : {p_Sect_Id: ddlSection, p_CB_Code: ddl_CB_Code, p_From_Date: fromVchrDate, p_To_Date: toVchrDate}});

    if (response.data.length > 0)
       setDetailRows(response.data);
    else 
      toast.error('No Voucher Found.');
    
  };

  const resetPage = () => {
    
    setDDL_CB_Code('');
    setDdlSection('');

    setDetailRows([{ 
      sect_id: "", fin_year1: "", vchr_no: "", vchr_type: "", cb_code: "", 
      vchr_date: "", bank_name: "", chq_no: "", amount: "", drcr: "", bank_date: ""}]);

    setDetailRows([]);
    // setIsEditMode(true);
  }

  const handleClear = () => {
    if (window.confirm("Sure you want to clear all data ?")) {
      resetPage();
    //  setDetailRows([]);
    }
  };

  function formatCurrency(amount) {
    const numberFormat = new Intl.NumberFormat('en-IN', {
      style: 'decimal', //'currency',
      minimumFractionDigits: 2,
      currency: 'INR',
      currencyDisplay: 'symbol',
    });
    return numberFormat.format(amount);
  }

  const handleSave = async () => {

    let lv_found = 'F';

    for (let i = 0; i < detailRows.length; i++) {
      
        if (detailRows[i].bank_date)
        {
          lv_found = 'T';
          break;
        }

    }

    if (lv_found === 'F') {
      toast.error('Please enter Bank Date for atleast a Voucher.');
      return;
    }

    const isConfirmed = window.confirm("Update Bank Dates ?");

    if (!isConfirmed) return;

    const payload = {
      details: detailRows,
    };

    try {
      const response = await axios.post(`${BASE_URL}/api/save_BankDates`, payload);
      if (response.data.message !== '0') {
        toast.success(`Updated Bank Dates successfully.`);
        resetPage();
      }
    } catch (err) {
      console.error("Save error:", err);
      toast.error("Failed to Update !");
    }
  };

  const totalAmount = detailRows.reduce((total, row) => {

    const amt = parseFloat(row.amount || 0);

    return row.drcr === "DR"
      ? total + amt
      : row.drcr === "CR"
        ? total - amt
        : total;
  }, 0);

  const totalDrCr = totalAmount >= 0 ? "DR" : "CR";

  return (
    <Container fluid className="p-3">
      {/* Header */}
      <Card className="p-3 mb-4">
        <Row className="mb-3">

          <Col md={3}>
            <Form.Label>Section</Form.Label>
            <Form.Select
              className="form-select"
              name="ddlSection"
              value={ddlSection}
              onChange={(e) => setDdlSection(e.target.value)}
              disabled={detailRows.length > 0}
            >
              <option value="">-- Select Section --</option>
              {ddlSections.map(sec => (
                <option key={sec.section_id} value={sec.section_id}>{sec.section_desc}</option>
              ))}
            </Form.Select>
          </Col>

          <Col md={5}>
            <Form.Label>Cash/Bank A/c</Form.Label>
            <Form.Select className="form-select" name="ddl_CB_Code" value={ddl_CB_Code} 
              onChange={(e) => setDDL_CB_Code(e.target.value)} disabled={detailRows.length > 0} >
              <option value="">-- Select Cash/Bank --</option>
              {ddl_CB_Codes.map((cb) => (
                <option key={cb.cb_code} value={cb.cb_code}>
                  {cb.cb_name}
                </option>
              ))}
            </Form.Select>
          </Col>

          <Col md={2}>
            <Form.Label>From Voucher Date</Form.Label>
            <Form.Control type="date" name="fromVchrDate" className="form-control" disabled={detailRows.length > 0}
              value={fromVchrDate} onChange={(e) => setFromVchrDate(e.target.value)}  />
          </Col>

          <Col md={2}>
            <Form.Label>To Voucher Date</Form.Label>
            <Form.Control type="date" name="toVchrDate" className="form-control" disabled={detailRows.length > 0}
              value={toVchrDate} onChange={(e) => setToVchrDate(e.target.value)}  />
          </Col>

        </Row>

        <Row className="mb-3">

          <Col md={12} className="d-flex justify-content-end">
            <Button style={{height: '40px', marginTop: '10px', width: '130px'}} className="me-2" variant="primary" 
                  disabled={detailRows.length > 0} onClick={handleShowData}>Show Data</Button>
            <Button style={{height: '40px', marginTop: '10px', width: '130px'}} className="me-2" variant="secondary" 
              disabled={detailRows.length === 0} onClick={handleClear}>Clear</Button>
            <Button style={{ height: '40px', marginTop: '10px', width: '130px' }} className="me-2" variant="success"
              disabled={detailRows.length === 0} onClick={handleSave}>Save</Button>
          </Col>
          
        </Row>

      </Card>

      {/* Details Table */}
      <Card className="p-3">
        <div style={{ minHeight: '220px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">
            <thead>
              <tr>
                <th style={{width: '4%', textAlign: 'center'}}>#</th>
                <th style={{width: '8%', textAlign: 'left'}}>Voucher No</th>
                <th style={{width: '9%', textAlign: 'left'}}>Voucher Date</th>
                <th style={{width: '28%', textAlign: 'left'}}>Bank Name</th>
                <th style={{width: '9%', textAlign: 'left'}}>Chq No</th>
                <th style={{width: '10%', textAlign: 'right'}}>Amount</th>
                <th style={{width: '3%', textAlign: 'center'}}>Dr/Cr</th>
                <th style={{width: '12%', textAlign: 'center'}}>Bank Date</th>
              </tr>
            </thead>
            <tbody>
              {detailRows.map((row, index) => (
                <tr key={index}>
                  <td style={{ width: "5%", textAlign: 'center' }}>{index + 1}</td>
                  <td style={{ textAlign: 'left'}}> {row.vchr_type}-{row.vchr_no} </td>
                  <td> {row.vchr_date} </td>
                  <td> {row.bank_name} </td>
                  <td> {row.chq_no} </td>
                  <td style={{ textAlign: 'right'}}> {formatCurrency(row.amount)} </td>
                  <td style={{ textAlign: 'center'}}> {row.drcr} </td>
                  <td>
                    <input type="date" name="bank_date" className="form-control"
                      value={row.bank_date} 
                      onChange={(e) => handleDetailChange(index, e)} />
                  </td>
                </tr>
              ))}
            </tbody>
            {detailRows.length > 0 &&
              <tfoot>
                <tr style={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}>
                  <td colSpan={5} style={{ textAlign: "right" }}>
                    Total :
                  </td>

                  <td style={{ textAlign: "right" }}>
                    {formatCurrency(Math.abs(totalAmount))}
                  </td>

                  <td style={{ textAlign: "center" }}>
                    {totalDrCr}
                  </td>

                  <td colSpan={1}></td>
                </tr>
              </tfoot>
            }
          </table>
        </div>

      </Card>

    </Container>
  );
};

export default Bank_Reconciliation;
